import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { DmsFile } from '../../modal/upload/model/upload.model';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-critical-design',
  standalone:false,
  templateUrl: './critical-design.component.html',
  styleUrl: './critical-design.component.scss'
})
export class CriticalDesignComponent implements OnInit , AfterViewInit , OnDestroy {
@Input() id: any
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  rfpdata: any;
  uploadedFileName: string = '';
  file: File;
  private subscriptions = new Subscription();
  userID: any;
  allDmsFiles: any[]=[];
  constructor(private fb: FormBuilder, private messageService: MessageService, 
    private uploadService : UploadService,
    private api: ApiService, private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
    });
     const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.getRfpDetails();

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this,this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  goToNextStep() {
    this.stepCompleted.emit();
  }

  getRfpDetails(): void {
    let apiUrl = `/tdf/critical/design/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;

    // Call API
    const sub = this.api.getAPI(apiUrl).subscribe((res: any) => {
      this.rfpdata = res[0];
      console.log('this critical data',this.rfpdata);      
      const dmsFiles: DmsFile[] = this.rfpdata.dms_files;
        this.allDmsFiles = dmsFiles;
      this.uploadedUrl =  this.rfpdata?.file ;
      this.commentForm.patchValue({
        comment: this.rfpdata?.comment
      });
    });
    this.subscriptions.add(sub);
  }

    // this is use for upload document table
  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    formData.append('comment', this.commentForm.get('comment')?.value || '');

    if (this.file) {
      formData.append('file', this.file);
    }
    const baseUrl = `/tdf/critical/design/`;

    if (this.rfpdata?.id) {
      const sub = this.api.putAPI(`${baseUrl}${this.rfpdata.id}/`, formData).subscribe((res: any) => {
        this.uploadedFileName = ''
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data updated successfully'
        });
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(baseUrl, formData).subscribe((res: any) => {
         this.uploadedFileName = ''
        this.fileUpload.clear();
        this.getRfpDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Data uploaded successfully'
        });
      });
    }
  }


  generatePDF() {
    const payload =  {
      url: '/revenue/need/version-control/',
      data: [
      { key: "Proposal Name", value: this.payload.proposal_name },
      { key: "Comment", value: this.commentForm.get('comment')?.value },
    ]
  }
    this.generatePDFEmitter.emit(payload);
  }

 getFileName(url: string): string {
  const fileName = url.split('/').pop() || 'Unknown File';
  return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
}
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }

}
